<ng-container>
	<div class="icon iconHeating" [ngClass]="getClasses('heating')"></div>
	<div class="icon iconDomesticWater" [ngClass]="getClasses('dhw')"></div>
	<div class="icon iconOperationTime" [ngClass]="getClasses('operationTime')"></div>
	<div class="icon off"></div>
	<div class="icon iconBurner" [ngClass]="getClasses('burner')"></div>
	<div class="icon iconEcoMode" [ngClass]="getClasses('ecomode')"></div>
	<div class="icon off"></div>
</ng-container>